import { IChaletState } from "../data/chaletapi";
import { Chalet, HeatingDevice } from "./chalet.interface";

function mapInitState(chaletState: IChaletState): Chalet {
  const chalet: Chalet = {
    isInitilized: true,
    rooms: {
      ParentsRoom: {
        id: "ParentsRoom",
        name: "Bed Room",
        switchId: "1",
        switch_state: true,
        thermId: "th1",
        thermState: "Off",
        actualTemp: 10.0,
        targetTemp: 18.5,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "JEQ0225146:2",
        addressSwitch: "JEQ0568481:2",
        addressActualTemp: "JEQ0225146:1",
      },
      GuestRoom: {
        id: "GuestRoom",
        name: "Guest Room",
        switchId: "1",
        switch_state: true,
        thermId: "th1",
        thermState: "On",
        actualTemp: 10.0,
        targetTemp: 18.5,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "KEQ0176420:2",
        addressSwitch: "JEQ0568651:2",
        addressActualTemp: "KEQ0176420:1",
      },
      KidsRoom: {
        id: "KidsRoom",
        name: "Kids Room",
        switchId: "1",
        switch_state: false,
        thermId: "th1",
        thermState: "On",
        actualTemp: 10.0,
        targetTemp: 18.0,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "JEQ0224937:2",
        addressSwitch: "JEQ0568481:1",
        addressActualTemp: "JEQ0224937:1",
      },
      BathRoom: {
        id: "BathRoom",
        name: "Bath",
        switchId: "1",
        switch_state: true,
        thermId: "th1",
        thermState: "On",
        actualTemp: 10.0,
        targetTemp: 18.5,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "JEQ0225163:2",
        addressSwitch: "JEQ0568481:3",
        addressActualTemp: "JEQ0225163:1",
      },
      Upstairs: {
        id: "Upstairs",
        name: "Living",
        switchId: "1",
        switch_state: true,
        thermId: "th1",
        thermState: "On",
        actualTemp: 10.0,
        targetTemp: 18.5,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "JEQ0225266:2",
        addressSwitch: "JEQ0568651:1",
        addressActualTemp: "JEQ0225266:1",
      },
      BathRoomUpstairs: {
        id: "BathRoomUpstairs",
        name: "Bath Upstairs",
        switchId: "1",
        switch_state: true,
        thermId: "th1",
        thermState: "On",
        actualTemp: 10.0,
        targetTemp: 18.5,
        targetTempOff: 8.0,
        targetTempOn: 18.0,
        addressSetPoint: "KEQ0175968:2",
        addressSwitch: "JJEQ0568271:1",
        addressActualTemp: "KEQ0175968:1",
      },
    },
    devices: {
      Boiler: {
        id: "Boiler",
        name: "Boiler",
        switch: false,
        state: false,
        temp1: 18.4,
        temp2: 18.5,
        deviceType: 1,
        address: "00259F29991FE1:10",
      },
      FloorHeatingPump: {
        id: "FloorHeatingPump",
        name: "Foor Heating",
        switch: false,
        state: false,
        temp1: 18.4,
        temp2: 18.5,
        deviceType: 3,
        address: "00259F29991FE1:14",
      },
      "Fire Place": {
        id: "Fire Place",
        name: "Fire Place",
        switch: false,
        state: false,
        temp1: 18.4,
        temp2: 18.5,
        deviceType: 2,
        address: "00259F29991FE1:18",
      },
      ZoneValve: {
        id: "ZoneValve",
        name: "Zone Valve",
        switch: false,
        state: false,
        temp1: 18.4,
        temp2: 18.5,
        deviceType: 4,
        address: "00259F29991FE1:18",
      },
    },
    lastUpdate: "not yet",
    outside: 15.5,
    live: chaletState.live === true,
    lights: {},
  };

  for (const light of chaletState.lights ?? []) {
    chalet.lights[light.id] = { id: light.id, name: light.name, switch: light.on, state: light.on };
  }

  const vbusMap: Record<string, { device: string, param: string, ptype: string }> = {
    "Floor Heating Circulation": { device: "FloorHeatingPump", param: "state", ptype: 'bool' },
    "Fireplace Circulation": { device: "Fire Place", param: "state", ptype: 'bool' },
    "FloorHeating": { device: "FloorHeatingPump", param: "temp1", ptype: 'number' },
    //"Outside": { device: "Outside", param: "temp1", ptype: 'number' },
    "FirePlace": { device: "Fire Place", param: "temp1", ptype: 'number' },
    "BoilerTop": { device: "Boiler", param: "temp1", ptype: 'number' },
    "BoilerBottom": { device: "Boiler", param: "temp2", ptype: 'number' }
  }

  // returns the value as number, or undefined if it is missing / not numeric
  function toNumber(value: any): number | undefined {
    if (value === undefined || value === null || value === "") return undefined
    const n = Number(value)
    return Number.isFinite(n) ? n : undefined
  }

  //console.log(chaletState.rooms);

  for (const room of chaletState.rooms) {
    if (!Object.hasOwn(chalet.rooms, room.room)) {
      console.log("unknown room:", room.room);
      continue
    }
    const stateRoom = chalet.rooms[room.room];
    // the server may return several rows per room, each with only some measurements set
    stateRoom.actualTemp = toNumber(room.TEMPERATURE) ?? stateRoom.actualTemp;
    stateRoom.targetTemp = toNumber(room.SETPOINT) ?? stateRoom.targetTemp;
    stateRoom.targetTempOn = toNumber(room.TARGETON) ?? stateRoom.targetTempOn;
    stateRoom.targetTempOff = toNumber(room.TARGETOFF) ?? stateRoom.targetTempOff;

    const thermState = toNumber(room.STATE)
    if (thermState !== undefined) {
      stateRoom.thermState = thermState === 0 ? "Off" : "On";
    }
  }
  // on when the setpoint is closer to the on target than to the off target
  for (const room of Object.values(chalet.rooms)) {
    room.switch_state = room.targetTemp > (room.targetTempOn + room.targetTempOff) / 2;
  }
  for (const device of chaletState.heating) {
    // the heating query also returns TEMPERATURE rows; only STATE is a switch state
    if (device._measurement !== undefined && device._measurement !== "STATE") {
      continue
    }
    if (!Object.hasOwn(chalet.devices, device.channelName)) {
      console.log("unknown device:", device.channelName);
    } else {
      const dev = chalet.devices[device.channelName];
      dev.switch = toNumber(device._value) === 1;
    }
  }

  function updateDev<Key extends keyof HeatingDevice>(dev: HeatingDevice, key: Key, value: HeatingDevice[Key]) {
    //console.log(key,value)
    dev[key] = value
  }

  for (const vbusrecord of chaletState.vbus) {
    const device = vbusrecord.device
    if (device === "Outside") {
      const outside = toNumber(vbusrecord._value)
      if (outside !== undefined) {
        chalet.outside = Math.round(outside * 10) / 10
      }
    } else if (!Object.hasOwn(vbusMap, device)) {
      console.log("unknown device:", device);
    } else {
      const deviceinfo = vbusMap[device]
      const dev = chalet.devices[deviceinfo.device];
      const param = deviceinfo.param as keyof HeatingDevice
      const ptype = deviceinfo.ptype

      const raw = toNumber(vbusrecord._value)
      if (raw === undefined) {
        continue
      }
      var value: number | boolean = 0
      if (ptype == 'number') {
        value = Math.round(raw * 100) / 100
      }
      if (ptype == 'bool') {
        value = raw !== 0
      }
      updateDev(dev, param, value)
    }
  }


  //console.log(chalet);

  return chalet;
}

export default mapInitState;
